<div class="row">
	<div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Cognome e nome'"
		[valueInput]="(altraParte.parte.cognome ? altraParte.parte.cognome : '')+(altraParte.parte.nome ? (' ' + altraParte.parte.nome) : '')"></div>
	<div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Tipo persona'"
		[valueInput]="altraParte.parte.tipoPersona?.label"></div>
	<div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'boolean'"
		[labelInput]="'Dipendente'" [valueInput]="altraParte.parte?.dipendente"></div>
	<div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Matricola'" [valueInput]="altraParte.parte?.matricola"></div>
	<div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Codice fiscale'"
		[valueInput]="altraParte.parte.codiceFiscale"></div>
</div>
<div class="row">
	<div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Ragione Sociale'"
		[valueInput]="altraParte.parte?.ragioneSociale"></div>
	<div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Partita Iva'"
		[valueInput]="altraParte.parte?.partitaIva"></div>
	<div labelTextInput class="col-xs-12 col-sm-3 bloccodati" [typeLabel]="'text'"
		[labelInput]="'CF Rappresentante legale'"
		[valueInput]="altraParte.parte?.codiceFiscaleRappresentanteLegale"></div>
	<div labelTextInput class="col-xs-12 col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Tipo societ&agrave;'"
		[valueInput]="altraParte.parte.tipoSocieta?.label"></div>
</div>

<div class="row">
  <div labelTextInput class="col-xs-12 col-sm-12 bloccodati" [typeLabel]="'text'" [labelInput]="'Nominativo originale'"
       [valueInput]="altraParte.parte?.nominativoOriginale ? altraParte.parte?.nominativoOriginale : ''">
  </div>
</div>

<div class="row container_fieldset">
	<div class="col-sm-12 col-xs-12">
		<fieldset class="form-group">
			<legend>Nascita <span class="sr-only">altra parte</span></legend>
			<div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'date'"
				[labelInput]="'Data'" [valueInput]="altraParte.parte?.dataNascita"></div>
			<div labelTextInput class="col-sm-5 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Comune'"
				[valueInput]="altraParte.parte.comuneNascita?.label"></div>
			<div labelTextInput class="col-sm-5 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Provincia'"
				[valueInput]="altraParte.parte.provinciaNascita?.label"></div>
		</fieldset>
	</div>
</div>

<div class="row container_fieldset">
	<div class="col-sm-12 col-xs-12">
		<fieldset class="form-group">
			<legend>Residenza <span class="sr-only">altra parte</span></legend>
			<div labelTextInput class="col-sm-8 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Indirizzo'" [valueInput]="altraParte.parte?.indirizzo"></div>
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Cap'" [valueInput]="altraParte.parte?.cap"></div>
			<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Comune'"
				[valueInput]="altraParte.parte.comuneResidenza?.label"></div>
			<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Provincia'"
				[valueInput]="altraParte.parte.provinciaResidenza?.label"></div>
		</fieldset>
	</div>
</div>

<div class="row container_fieldset">
	<div class="col-sm-12 col-xs-12">
		<fieldset class="form-group">
			<legend>Contatti <span class="sr-only">altra parte</span></legend>
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Telefono'" [valueInput]="altraParte.parte.telefono"></div>
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Cellulare'" [valueInput]="altraParte.parte.cellulare"></div>
			<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Fax'" [valueInput]="altraParte.parte.fax"></div>
			<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Email'" [valueInput]="altraParte.parte.email"></div>
			<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
				[labelInput]="'Pec'" [valueInput]="altraParte.parte.pec"></div>
		</fieldset>
	</div>
</div>
			<div class="row">
				<div class="col-xs-12 col-sm-12 bloccodati">
					<p>
						<label class="col-sm-12">Note</label>
						<span class="longtext">{{ altraParte.parte.note }}</span>
					</p>
				</div>
<!-- 				<div labelTextInput class="col-sm-12 bloccodati" -->
<!-- 					[typeLabel]="'text'" [labelInput]="'Note'" -->
<!-- 					[valueInput]="altraParte.parte.note"></div> -->
			</div>
<!-- <div class="row">
	<p class="col-sm-3 col-sm-offset-9 col-xs-3 col-xs-offset-9">
		<button type="button" class="btn btn-primary btn-block"
			(click)="openModAnagrafica(altraParte.parte)">Modifica dati</button>
	</p>
</div> -->
